import React from "react";

/**
 * Filas fantasma mientras llega la información.
 *
 * Reemplaza al loader que tapaba la pantalla: la tabla ya está dibujada con sus
 * encabezados y sólo el contenido "late", así que no hay salto de layout cuando
 * llegan los datos.
 */
export default function TableSkeleton({ columnas, filas = 6 }) {
  return (
    <>
      {Array.from({ length: filas }).map((_, fila) => (
        <tr key={fila} className="dtable-skeleton-row">
          {columnas.map((col, i) => (
            <td key={col.field || i}>
              <span
                className="dtable-skeleton-barra"
                style={{ width: `${55 + ((fila * 7 + i * 13) % 40)}%` }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
